import 'dayjs/locale/nl';
import 'dayjs/locale/en';

import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import weekOfYear from 'dayjs/plugin/weekOfYear';

dayjs.extend(weekOfYear);
dayjs.extend(timezone);

export const setTimezone = (timezone: string): void => {
  dayjs.tz.setDefault(timezone);
};

export const setLocale = (locale: string): void => {
  dayjs.locale(locale);
};
